var MainMenuLeftSideBar = null;

(function () {
    $(function () {
        var SideBAR;
        SideBAR = (function () {
            function SideBAR() { }

            SideBAR.prototype.expandMyMenu = function () {
                if ($("#divPanelSelection").length > 0 && ($("#divPanelSelection").hasClass("panel-selection-expanded")))
                    $("#divPanelSelection").removeClass("panel-selection-expanded").addClass("panel-collapsed");
                if ($("#dragSplitter").length > 0 && ($("#dragSplitter").hasClass("panel-splitter-expanded")))
                    $("#dragSplitter").removeClass("panel-splitter-expanded").addClass("panel-collapsed");
                $("#divMain").removeClass("centerContentForPanelSelection").removeClass("centerContentExpanded").addClass("centerContent");             
                $("#divSidebar").addClass("sidebar");
                var res = $("#divSidebar").removeClass("panel-collapsed").addClass("panel-expanded");
                $('#divMain').css('left', $("#divSidebar").css('width'));
                return res;
            };

            SideBAR.prototype.collapseMyMenu = function () {
                if ($("#divPanelSelection").length < 1) {
                    $("#divMain").removeClass("centerContentForPanelSelection").removeClass("centerContent").addClass("centerContentExpanded");
                    $('#divMain').css('left', '0px');
                }
                else if ($("#divPanelSelection").hasClass("panel-collapsed")) {
                    $("#divPanelSelection").removeClass("panel-collapsed").addClass("panel-selection-expanded");
                    $("#divMain").removeClass("centerContentExpanded").addClass("centerContentForPanelSelection");
                    if ($("#dragSplitter").length > 0 && ($("#dragSplitter").hasClass("panel-collapsed"))) {
                        $("#dragSplitter").removeClass("panel-collapsed").addClass("panel-splitter-expanded");
                        $('#dragSplitter').css('left', $("#divPanelSelection").width());
                    }
                    $('#divMain').css('left', $("#divPanelSelection").width());
                }
                $("#divSidebar").removeClass("sidebar");
                return $("#divSidebar").removeClass("panel-expanded").addClass("panel-collapsed");
            };

            SideBAR.prototype.showMenuTexts = function () {
                $("#divSidebar div a span.caret").show();
                return $("#divSidebar div a span.expanded-element").show();
            };

            SideBAR.prototype.hideMenuTexts = function () {
                $("#divSidebar div a span.caret").hide();
                return $("#divSidebar div a span.expanded-element").hide();
            };

            SideBAR.prototype.showActiveSubMenu = function () {
                $("div.active div.level2").show();
                return $("div.active a.expandable").css({
                    width: "100%"
                });
            };           

            SideBAR.prototype.hideActiveSubMenu = function () {
                return $("div.active div.level2").hide();
            };

            SideBAR.prototype.adjustPaddingOnExpand = function () {
                $("div.level1 div a.expandable").css({
                    padding: "1px 4px 4px 0px"
                });
                return $("div.level1 div.active a.expandable").css({
                    padding: "1px 4px 4px 4px"
                });
            };

            SideBAR.prototype.resetOriginalPaddingOnCollapse = function () {
                $("div.level1 div a.expandable").css({
                    padding: "4px 4px 4px 0px"
                });
                return $("div.level1 div.active a.expandable").css({
                    padding: "4px"
                });
            };

            SideBAR.prototype.ExpandSideBar = function () {
                return (function (instance) {
                //$("#divSidebar").show();
                //instance.adjustPaddingOnExpand();
                instance.expandMyMenu();
                instance.showMenuTexts();
                instance.showActiveSubMenu();
                FixColumnWidthsForAllGridsWithFixedColumns();
                })(this);
            };

            SideBAR.prototype.CollapseSideBar = function () {
                return (function (instance) {
                //instance.resetOriginalPaddingOnCollapse();
                instance.collapseMyMenu();
                //instance.hideMenuTexts();
                //instance.hideActiveSubMenu();
                //$("#divSidebar").hide();
                FixColumnWidthsForAllGridsWithFixedColumns();
                })(this);
            };

            SideBAR.prototype.init = function () {
                return (function (instance) {
                    //instance.expandMyMenu();
                    //instance.showMenuTexts();
                    //instance.showActiveSubMenu();
                    $(this).css({
                        color: "#000"
                    });
                    MainMenuLeftSideBar = instance;
                    //instance.CollapseSideBar();
                    return instance;
                })(this);
            };

            SideBAR.prototype.ignite = function () {
                return (function (instance) {
                    return $("#justify-icon").on("click", function (e) {
                        if ($("#divSidebar").hasClass("panel-collapsed")) {
                            instance.ExpandSideBar();
                        } 
                        else if ($("#divSidebar").hasClass("panel-expanded")) {
                            instance.CollapseSideBar();
                        }
                        return false;
                    });
                })(this);
            };

            return SideBAR;

        })();
        return (new SideBAR).init().ignite();
    });

}).call(this);

function FixColumnWidthsForAllGridsWithFixedColumns() {
    if (typeof (ReportingGrid_FixColumnWidthsForAllGridsWithFixedColumns) == "function") {
        ReportingGrid_FixColumnWidthsForAllGridsWithFixedColumns();
    }
}